import { useEffect } from 'react';

export const useClickEsc = (isChanged: boolean, setIsChanged: (isChanged: boolean) => void) => {
  useEffect(() => {
    const closeModalOnEsc = (e: KeyboardEvent) => {
      if (isChanged && e.code === 'Escape') {
        setIsChanged(false);
      }
    };

    document.addEventListener<'keydown'>('keydown', closeModalOnEsc);

    return () => {
      document.removeEventListener<'keydown'>('keydown', closeModalOnEsc);
    };
  }, [isChanged]);
};
